/* eslint-disable @typescript-eslint/no-explicit-any */
export const copyToClipboard = (text: string): Promise<void> => {
   if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(text);
   }

   return new Promise((resolve, reject) => {
      const tempDiv = document.createElement('div');
      tempDiv.contentEditable = 'true';
      tempDiv.textContent = text;
      tempDiv.style.position = 'fixed';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '-9999px';

      document.body.appendChild(tempDiv);

      try {
         const range = document.createRange();
         range.selectNodeContents(tempDiv);

         const selection = window.getSelection();
         selection?.removeAllRanges();
         selection?.addRange(range);

         const success = (document as any).execCommand('copy');
         selection?.removeAllRanges();

         if (success) {
            resolve();
         } else {
            reject(new Error('Copy failed'));
         }
      } catch (error) {
         reject(error);
      } finally {
         document.body.removeChild(tempDiv);
      }
   });
};
